import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.SpendTrackerCategoryCard`

export default defineMessages({
  currentSpend: {
    id: `${scope}.currentSpend`,
    defaultMessage: 'Current spend',
  },
  currentRequest: {
    id: `${scope}.currentRequest`,
    defaultMessage: 'Current request',
  },
  spendAfterApproval: {
    id: `${scope}.spendAfterApproval`,
    defaultMessage: 'Spend after approval',
  },
  remainingAfterApproval: {
    id: `${scope}.remainingAfterApproval`,
    defaultMessage: 'Remaining after approval',
  },
  otherPendingRequests: {
    id: `${scope}.otherPendingRequests`,
    defaultMessage: 'Other pending requests',
  },
  budget: {
    id: `${scope}.budget`,
    defaultMessage: 'Budget',
  },
  budgetBreakdownTableLabel: {
    id: `${scope}.budgetBreakdownTableLabel`,
    defaultMessage: 'Budget breakdown',
  },
  categoryBreakdownTableLabel: {
    id: `${scope}.categoryBreakdownTableLabel`,
    defaultMessage: 'Category breakdown',
  },
  granularSpendTableLabel: {
    id: `${scope}.granularSpendTableLabel`,
    defaultMessage: 'Granular spend',
  },
})
